import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared';
import { IPaginationParams } from '../interfaces/IPaginationParamas';

@Injectable({
  providedIn: 'root',
})
export class UserTypeService {
  constructor(private http: HttpClient) {}
  getAllUserTypes(params: IPaginationParams) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    return this.http.get<ApiResponse>('/v1/admin/user-type', { params: httpParams });
  }
}
